import React, { useState } from 'react';
import Chart from '../../components/trader/Chart'; // Update path if needed

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('orders');

  const data = {
    orders: [
      { id: 1, symbol: 'AAPL', type: 'BUY', qty: 10, status: 'Filled' },
      { id: 2, symbol: 'TSLA', type: 'SELL', qty: 5, status: 'Pending' },
    ],
    holdings: [
      { id: 1, symbol: 'GOOGL', qty: 50, avgPrice: 142.50 },
      { id: 2, symbol: 'MSFT', qty: 20, avgPrice: 405.10 },
    ],
    positions: [
      { id: 1, symbol: 'NIFTY', qty: 50, pnl: 1250.75 },
      { id: 2, symbol: 'RELIANCE', qty: 100, pnl: -450.20 },
    ]
  };

  const totalPnL = data.positions.reduce((acc, pos) => acc + pos.pnl, 0);

  // Common Table Styling
  const tableHeaderClass = "text-left py-2 px-3 text-slate-500 font-medium border-b border-slate-800 text-xs uppercase";
  const tableCellClass = "py-3 px-3 border-b border-slate-800/50";




  return (
    /* Removed the calc(100vh-64px) because Layout already handles spacing */
    <div style={{ width: '100%', height: 'calc(100vh - 128px)', background: '#ffffff' }}>
      <div style={{ width: '100%', height: '100%', position: 'relative', padding:"2%" }}>
          <Chart />
      </div>
    </div>
  );

};

export default Dashboard;